import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useI18n } from "../i18n/I18nContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const { t } = useI18n();
  if (user === undefined)
    return (
      <div className="min-h-screen flex items-center justify-center text-[#627D98]">
        {t("loading")}
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (!user.onboarded) return <Navigate to="/onboarding" replace />;
  return children;
}
